/**
 * External Dependencies
 */
//import 'jquery';
import 'bootstrap';

import {gsap, Power1, Power2, Power3} from 'gsap';
//import { CSSRulePlugin } from "gsap/CSSRulePlugin";
import LazyLoad from 'vanilla-lazyload';
import ScrollAnimations from './ScrollAnimations';  // importing here our supercool Riot scroll animations framewok
import 'slick-carousel/slick/slick.min.js';
import '@fancyapps/fancybox/dist/jquery.fancybox.js';
import 'sharer.js/sharer.min.js';


// function needed for CF7, alongside custom css in forms.scss, this is just to add a class when field is not empty, to keep label on top
function floatingLabelsFix() {

  var $inputs = $(".form-floating input, .form-floating textarea");
  $inputs.on("input", function() {
    var $filled = $inputs.filter(function() { return this.value.trim().length > 0; });
    $(this).parent().toggleClass('floating-filled', $filled.length > 0);
  });
}



/* manage what happens on scroll. menu etc */
function manageScroll() {
  var currentScrollPos = window.pageYOffset;

  let currentMenuHeight = document.getElementById("main-navigation").clientHeight;

  if (prevScrollpos > currentScrollPos ) {
    document.getElementById("main-navigation").style.top = "0";
  } else {
    if (currentScrollPos >= 50){
      document.getElementById("main-navigation").style.top = "-" + currentMenuHeight + "px";
    }
  }
  if (currentScrollPos >= 50) {
    $('#main-navigation').addClass('scrolling');
  } else {
    $('#main-navigation').removeClass('scrolling');
  }
  prevScrollpos = currentScrollPos;
}




function startSlick() {
  $('.home-hero').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    infinite: false,
    fade: true,
    speed: 500,
    cssEase: "ease",
    useTransform: true,
    //fade: true,
    asNavFor: '.home-hero-nav',


  });
  $('.home-hero-nav').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.home-hero',
    dots: false,
    arrows: false,
    infinite: false,
    focusOnSelect: true,
    mobileFirst: true,
    useTransform: true,
    speed: 300,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          dots: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: false,
          dots: false
        }
      }
    ]
  });

}



// generic smooth scroll anchor animation
function smoothScroll() {

  $(document).on('click', 'a[href^="#"]:not(.playstation5, .xboxseriesx, .playstation, .xbox, .pc, .switch, .nav-tabs a, .iubenda-cs-preferences-link)', function (event) {
      event.preventDefault();
      $('html, body').animate({  scrollTop: $($.attr(this, 'href')).offset().top }, 1500);
  });

}


$( document ).ready(function() {


    // JavaScript to be fired on all pages



    // trova filiali aggiunta tasto per usare la propria posizione
    var trovaFilialiInt = setInterval(() => {
      // se url pagina è diverso da trova-filiali-e-atm non fare nulla
      if(window.location.href.indexOf('trova-filiali-e-atm') == -1) {
        clearInterval(trovaFilialiInt);
        return;
      }

      if(document.querySelector('#wpsl-search-wrap')) {
        clearInterval(trovaFilialiInt);
        var ancorUsaPosizione = document.createElement('a');
        ancorUsaPosizione.classList.add('usa-posizione');
        ancorUsaPosizione.innerHTML = 'Usa la tua posizione';
        ancorUsaPosizione.href = '#';
        ancorUsaPosizione.addEventListener('click', function(e) {
          e.preventDefault();
          document.querySelector('#wpsl-map-controls .wpsl-icon-direction').click();
        });
        document.querySelector('#wpsl-search-wrap').appendChild(ancorUsaPosizione);
      }
    }, 100);

    // make data-href work as links (for main menu items with dropdowns)
    // document.querySelectorAll('[data-href]').forEach( e,
    //   function () {
    //    e.addEventListener('click', function () {
    //       console.log ('clicked');
    //       window.location.href = e.getAttribute('data-href');
    //   });
    // });

    // document.querySelectorAll('[data-href]').forEach((e)=>{
    //   e.addEventListener('click', ()=>{
    //     console.log('click');
    //     window.location.href = e.getAttribute('data-href');
    //   })
    // })


     // offanvas menu mechanism, added on top of default collapse menu
    document.querySelector('[data-bs-toggle="offcanvas"]').addEventListener('click', function () {
    document.querySelector('.offcanvas-collapse').classList.toggle('open');


      if (this.getAttribute('aria-expanded') == 'false') {
        this.setAttribute('aria-expanded', 'true');
        document.body.setAttribute('aria-expanded', 'true');
      } else {
        this.setAttribute('aria-expanded', 'false');
        document.body.setAttribute('aria-expanded', 'false');
      }
    })







    /* When the user scrolls down, hide the navbar. When the user scrolls up, show the navbar */
    var prevScrollpos = window.pageYOffset;

    function handleScroll() {
      var currentScrollPos = window.pageYOffset;
      let currentMenuHeight = document.getElementById("main-navigation").clientHeight;

      if (prevScrollpos > currentScrollPos ) {
        document.getElementById("main-navigation").style.top = "0";
      } else {
        if (currentScrollPos >= 50){
          document.getElementById("main-navigation").style.top = "-" + currentMenuHeight + "px";
        }
      }
      if (currentScrollPos >= 50) {
        $('#main-navigation').addClass('scrolling');
      } else {
        $('#main-navigation').removeClass('scrolling');
      }
      prevScrollpos = currentScrollPos;
    }

    // Call handleScroll on page load
    handleScroll();

    // Call handleScroll on scroll
    window.onscroll = handleScroll;



    // Dropdown logic
    document.querySelectorAll('#main-navigation').forEach(function(navbar) {

      const allMenuItems = navbar.querySelectorAll('li.menu-item.dropdown, div.menu-item.dropdown');
      const allMenuItemsNoDropdown = navbar.querySelectorAll('.navbar-nav>li.menu-item:not(.dropdown), div.menu-item:not(.dropdown), .navbar-brand');
      const searchBar = navbar.querySelector('.menu-search-desktop input');

      // Dropdown logic when i hover on menu items with dropdown class
      allMenuItems.forEach(function(item) {

        item.addEventListener('mouseenter', function() {

          if(item.classList.contains('dropdown')) {
            allMenuItems.forEach(function(sub) {
              sub.classList.remove('dropdown-open');
            });
            item.classList.add('dropdown-open');
          }

        });

      });

      // Dropdown logic when i hover on menu items without dropdown class
      allMenuItemsNoDropdown.forEach(function(item) {

          item.addEventListener('mouseenter', function() {
            allMenuItems.forEach(function(sub) {
              sub.classList.remove('dropdown-open');
            });
          });

        }
      );

      // Dropdown logic when i leave the navbar
      navbar.addEventListener('mouseleave', function() {

        if(document.activeElement != searchBar) {
          allMenuItems.forEach(function(item) {
            item.classList.remove('dropdown-open');
          });
        }

      });


      // if i click outside searchBar, close dropdown
      document.addEventListener('click', function(e) {
        if(e.target != searchBar) {
          allMenuItems.forEach(function(item) {
            item.classList.remove('dropdown-open');
          });
        }
      });


    });


    new ScrollAnimations();


    // smoothScroll();

    startSlick();

    floatingLabelsFix();

    $( ".gallery a, .wp-block-gallery a" ).attr('data-fancybox', 'gallery').attr('data-width', '1600');
    $('[data-fancybox]').fancybox({
    youtube : {
            controls : 1,
            showinfo : 0,
        },
        vimeo : {
            color : 'f00',
        },
    });

    // initialize vanilla-lazyload
    var lazyLoadInstance = new LazyLoad({
      elements_selector: '.lazy'
    });

    // IUBENDA CONTROLLS - display a placeholder if user has not accepted cookie policy
    // Set intervall to check every 100ms
    var intervalll = setInterval(() => {
      // if document contains ._iub_cs_activate, add in the same div the phrase "Accetta l'informativa sui cookie per visualizzare l'elemento"
      if(document.querySelector('body ._iub_cs_activate')) {
        clearInterval(intervalll);
        document.querySelector('body ._iub_cs_activate').parentElement.classList.add('relative');
        setTimeout(() => {
          document.querySelector('body ._iub_cs_activate').parentElement.innerHTML += '<p class="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 phrase text-center text-black text-xs">Accetta l\'informativa sui cookie per visualizzare l\'elemento</p>';
        }, 3000);
        // every 100ms check if document contains ._iub_cs_activate, if not remove the phrase
        var intervallll = setInterval(() => {
          if(!document.querySelector('._iub_cs_activate')) {
            clearInterval(intervallll);
            document.querySelector('.phrase').remove();
          }
        },100);
      }
    },100);

});

//on document ready in js vanilla
document.addEventListener('DOMContentLoaded', function() {

  var isChatOpen = false;

  // function to load the chorally chat (not on small screens)
  function loadChorallyChat() {
    if (window.innerWidth >= 410 && !document.getElementById('chorallyChat')) {
      var script = document.createElement('script');
      script.id = 'chorallyChat';
      script.src = 'https://bancacambiano.chorally.com/messenger/static/embed.js?token=a2e51309762577e948b9aedfc66df7dcbde030ccf480a9ae';
      script.setAttribute('header-style', '');
      script.setAttribute('button-text', 'Chat');
      script.setAttribute('button-position', '');
      script.setAttribute('button-style', '');
      script.setAttribute('theme-color', '#005d7e');
      script.setAttribute('show-form', 'false');
      document.body.appendChild(script);
    }
  }

  // Run on initial load
  loadChorallyChat();

  // Run on window resize
  window.addEventListener('resize', loadChorallyChat);


  var isChatOpen = false;
  setTimeout(() => {
    // add an event click on #chorallyChatBtn
    document.getElementById('chorallyChatBtn').addEventListener('click', function() {
      //block the scroll of the body only on pointer coarse
      if (window.matchMedia('(pointer: coarse)').matches) {
        document.body.style.overflow = 'hidden';
        setTimeout(() => {
          // #chorallyChatContainer z-index to 1026
          document.getElementById('chorallyChatContainer').style.zIndex = '1026';
        }, 100);
      }
      isChatOpen = !isChatOpen;
    });
  }, 1000);
  // add an event click on #chorallyChatContainer
  setTimeout(() => {
    document.getElementById('chorallyChatContainer').addEventListener('click', function() {
      isChatOpen = !isChatOpen;
      if (window.matchMedia('(pointer: coarse)').matches) {
        if (isChatOpen) {
          //block the scroll of the body
          document.body.style.overflow = 'hidden';
          // #chorallyChatContainer z-index to 1026
          document.getElementById('chorallyChatContainer').style.zIndex = '1026';
        } else {
          //unblock the scroll of the body
          document.body.style.overflow = 'auto';
          // #chorallyChatContainer z-index to 1024
          document.getElementById('chorallyChatContainer').style.zIndex = '1024';
        }
      }
    });
  }, 1000);
});